import Publications from './Publications'
export default Publications
